import type {
  ClientJourneyPresentationV1,
  ExternalAfterFixProofClientSafeSummaryV1,
  ExternalProofSalesRoomClientSafeViewV1,
} from "@enrein/shared-contracts";
import type { ClientPortalShellViewV1 } from "@enrein/shared-contracts/client-link";
import type { DeployEnvironment } from "@enrein/shared-contracts/deploy-env";
import type { PreviewViewV1 } from "@enrein/shared-contracts/approval-change";
import type { ClientPortalApiClient } from "../../api.js";

export type GreenfieldClientLocationContext = {
  readonly clientLinkId: string;
  readonly token: string;
};

export type GreenfieldClientHubProps = {
  readonly shell: ClientPortalShellViewV1;
  readonly preview: PreviewViewV1 | null;
  readonly sessionToken: string;
  readonly locationContext: GreenfieldClientLocationContext;
  readonly externalProofView: ExternalProofSalesRoomClientSafeViewV1 | null;
  readonly afterFixProofSummary: ExternalAfterFixProofClientSafeSummaryV1 | null;
  readonly deployEnv: DeployEnvironment;
  readonly changeMessage: string;
  readonly setChangeMessage: (value: string) => void;
  readonly onApprove: () => void;
  readonly onRequestChange: () => void;
  readonly actionStatus: string | null;
  readonly onActionStatus: (message: string | null) => void;
  readonly isExternalProof: boolean;
  readonly api: ClientPortalApiClient;
  readonly journeyPresentation?: ClientJourneyPresentationV1 | null;
};

export const GREENFIELD_CLIENT_TABS = [
  "intake",
  "home",
  "preview",
  "review",
  "changes",
  "requests",
  "records",
  "help",
] as const;

export type GreenfieldClientTabId = (typeof GREENFIELD_CLIENT_TABS)[number];

export const GREENFIELD_TAB_LABELS: Record<GreenfieldClientTabId, string> = {
  intake: "Intake",
  home: "My Business",
  preview: "Website",
  review: "Review",
  changes: "Changes",
  requests: "Requests",
  records: "Records",
  help: "Help",
};
